<button mat-raised-button
        [color]="color"
        [disabled]="disabled || isLoading"
        (click)="onClick($event)">
  <mat-spinner *ngIf="isLoading" [diameter]="20" class="mr-2 d-inline-block"></mat-spinner>

  <ng-content></ng-content>
</button>